import script from "./SetPasswordPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SetPasswordPage.vue?vue&type=script&setup=true&lang=js"

import "./SetPasswordPage.vue?vue&type=style&index=0&id=5e452f2e&lang=scss"

const __exports__ = script;

export default __exports__